import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { UiSelect, UiToggle, UiActioButton, UiButton, PageError, BgLoader, InLoader, TableZero } from "../../ui";
import { useOutletContext } from "react-router-dom";
import { Uploader, DocList } from "../../uploader";



export default function TaskSupportingFiles() {
  const [pstate, setPSate] = useOutletContext();

  const [state, setState] = useState({});






  const fetchData = () => {
    setState({ ...state, loader: true })
    instance
      .get("/task_supporting_files?id=" + pstate.task.id)
      .then(function (response) {
        setState({ ...state, loader: false })
        setState({ ...state, ...response.data });



      })
      .catch(function (error) { })
      .then(function () { });

  }





  useEffect(() => {
    fetchData();
  }, []);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }


  return (<>
    {state.documents ?
      <div className="card card-default">
        <div className="card-body">
          {state.documents.length > 0 ? (
            <div className="position-relative" >
              <DocList category="service" setData={(e) => setState({ ...state, documents: e })} data={state.documents} can_edit={0} />
              {state.loader && <InLoader />}

            </div>
          ) : state.documents && state.documents.length == 0 && <TableZero title="Files" />}

        </div>

      </div>
      : <BgLoader />}
  </>
  )

}

